import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { Environments } from '~/config/environment';

export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: Environments.API_URL ?? '',
    // Always send cookie to cross-origin for now
    credentials: 'include',
    prepareHeaders: (headers) => {
      const language = window.localStorage.getItem('i18nextLng');

      if (language) {
        headers.set('language', language);
      }
      headers.set('Access-Control-Allow-Origin', '*');

      return headers;
    },
  }),
  endpoints: () => ({}),
});
